import { Customer } from "ApiGen/CustomerVerificationV2/model/models";
import { CustomerVerificationMock } from "./customer-verification-mock";

export class CustomerVerificationV2 implements Customer {
    firstName: string;
    lastName: string;
    ssn: string;
    address: string;
    city?: string | undefined;
    zip?: string | undefined;
    state?: string | undefined;
    dobDay?: string | undefined;
    dobMonth?: string | undefined;
    dobYear?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    mock?: CustomerVerificationMock;
 
    constructor( firstName: string,
                    lastName: string,
                    ssn: string,
                    address: string,) 
    { 
        this.firstName = firstName;
        this.lastName = lastName;
        this.ssn = ssn;
        this.address = address;
    }
}